import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';

import { useForm, Controller } from "react-hook-form";

import statesList from '../Helpers/StatesList';

import { Select, Transfer, Empty, List, Switch, Table, Spin } from 'antd';

import { getAllFacilities, isUsernameUnique, isEmailUnique, getUserInformationByID, updateUser } from '../../common/services/ApiService';
import { createUser } from '../../common/services/AuthService';

import { toast } from '@rickylandino/react-messages';
import NumberFormat from 'react-number-format';
import { allFacilities, allUsers } from '../../common/services/ReportService';
import { getManageFacilityInformation, insertFacilityLogo, updateFacilityInformation } from '../../common/services/FacilityService';
import { Radio } from 'react-bootstrap';
import RadiologistModal from '../Maintenance/RadiologistModal';
import { useToggle } from '../Helpers/CustomHooks';
import ProviderModal from '../Maintenance/Providers/ProviderModal';
import ManageUser from './ManageUser';
import IssuerOfPatientModal from '../Maintenance/IssuerOfPatientModal';
import PCPModal from '../Maintenance/PCPModal';
import CategoryModal from '../Maintenance/CategoryModal';

import difference from 'lodash/difference';
import { Editor } from '@tinymce/tinymce-react';
import { FACILITY_INTERFACE_TYPES } from '../../common/services/next-gen/FacilityService';

const TableTransfer = React.memo(({ leftColumns, rightColumns, updateUsers, ...restProps }) => (
    <Transfer {...restProps}>
        {({
            direction,
            filteredItems,
            onItemSelectAll,
            onItemSelect,
            selectedKeys: listSelectedKeys,
            disabled: listDisabled,
        }) => {
            const columns = direction === 'left' ? leftColumns : rightColumns;

            const rowSelection = {
                getCheckboxProps: item => ({ disabled: listDisabled || item.disabled }),
                onSelectAll(selected, selectedRows) {
                    const treeSelectedKeys = selectedRows
                        .filter(item => !item.disabled)
                        .map(({ key }) => key);
                    const diffKeys = selected
                        ? difference(treeSelectedKeys, listSelectedKeys)
                        : difference(listSelectedKeys, treeSelectedKeys);
                    onItemSelectAll(diffKeys, selected);
                },
                onSelect({ key }, selected) {
                    onItemSelect(key, selected);
                },
                selectedRowKeys: listSelectedKeys,
            };

            return (
                <Table
                    rowSelection={rowSelection}
                    columns={columns}
                    dataSource={filteredItems}
                    size="small"
                    scroll={{ y: 300 }}
                    pagination={false}
                    style={{ pointerEvents: listDisabled ? 'none' : null }}
                    onRow={({ key, disabled: itemDisabled }) => ({
                        onClick: (e) => {
                            if (itemDisabled || listDisabled) return;
                            if (e.target.name !== 'techOverride') {
                                onItemSelect(key, !listSelectedKeys.includes(key));
                            } else {
                                const itemToUpdate = filteredItems.find(fi => fi.userID === key);

                                itemToUpdate.techOverride = e.target.checked ? 1 : 0;

                                updateUsers(itemToUpdate);
                            }

                        },
                    })}
                />
            );
        }}
    </Transfer>
));

const leftTableColumns = [
    {
        dataIndex: 'fName',
        title: 'Name',
        render: (text, record) => (
            <span>{record.fName} {record.lName}</span>
        )
    }
];
const rightTableColumns = [
    {
        dataIndex: 'fName',
        title: 'Name',
        render: (text, record) => (
            <span>{record.fName} {record.lName}</span>
        ),
    }, {
        title: 'Is Tech',
        key: 'action',
        dataIndex: 'techOverride',
        render: (text, record) => {
            return (
                <div className="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" className="custom-control-input" name="techOverride" checked={(record.techOverride === 1) ? true : false} readOnly />
                    <label className="custom-control-label"></label>
                </div>
            )
        },
        align: 'right'
    },
];

function ManageFacility(props) {

    const states = useMemo(() => statesList.filter(obj => obj.country_code === 'US'), []);

    const [isLoading, setIsLoading] = useState(true);
    const [lists, setLists] = useState({
        allRadiologists: [],
        defaultRadiologistOptions: [],
        targetRadiologists: [],
        allProviders: [],
        defaultProviderOptions: [],
        targetProviders: [],
        allTechs: [],
        allExamTypes: [],
        allIssuers: [],
        allUsers: [],
        targetUsers: [],
        defaultUserOptions: [],
        primaryCarePhysicians: [],
        allCategories: [],
        targetCategories: []
    });

    const [showPane, setShowPane] = useState(true);

    const theme = window.sessionStorage.getItem("theme");

    const { register, handleSubmit, setValue, getValues, formState: { errors }, control, reset } = useForm({
        mode: 'onBlur',
        defaultValues: {
            facility: {}
        }
    });

    const [radiologistsToUpdate, setRadiologistsToUpdate] = useState([]);
    const [showAddRadiologist, setShowAddRadiologist] = useToggle();

    const [providersToUpdate, setProvidersToUpdate] = useState([]);
    const [showAddProvider, setShowAddProvider] = useToggle();

    const [usersToUpdate, setUsersToUpdate] = useState([]);
    const [showAddUser, setShowAddUser] = useToggle();

    const [categoriesToUpdate, setCategoriesToUpdate] = useState([]);
    const [showAddCategory, setShowAddCategory] = useToggle();

    const [showAddIssuer, setShowAddIssuer] = useToggle();
    const [showAddPCP, setShowAddPCP] = useToggle();

    const [facilityLogo, setFacilityLogo] = useState(null);

    const [logoData, setLogoData] = useState(null);

    const { Option } = Select;

    // Memoize flattenObject function
    const flattenObject = useCallback((obj) => {
        const flattened = {}

        Object.keys(obj).forEach((key) => {
            const value = obj[key]

            if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                Object.assign(flattened, flattenObject(value))
            } else {
                flattened[key] = value
            }
        })

        return flattened;
    }, []);

    // Optimized getCommonItems using Map for O(n) complexity instead of O(n�)
    const getCommonItems = useCallback((array1, array2, idName) => {
        const map = new Map();
        array2.forEach(item => map.set(item[idName], item));

        return array1
            .filter(item => map.has(item[idName]))
            .map(item => ({
                ...item,
                techOverride: map.get(item[idName]).technologistYN
            }));
    }, []);

    useEffect(() => {
        let isMounted = true;

        const loadData = async () => {
            try {
                setIsLoading(true);
                const data = await getManageFacilityInformation(props.facilityID);

                if (!isMounted) return;

                // Filter inactive items once
                const filterInactive = (items) => items?.filter(item => item.inactiveYN !== 1) || [];

                // Process user data
                const flatList = data.facilityUsersWithTechOverride
                    ? filterInactive(data.facilityUsersWithTechOverride.map(obj => flattenObject(obj)))
                    : filterInactive(data.allUsers);

                // Batch all state updates into one
                const newLists = {
                    allRadiologists: filterInactive(data.allRadiologists),
                    allTechs: filterInactive(data.allTechs),
                    allExamTypes: filterInactive(data.allExamTypes),
                    allIssuers: filterInactive(data.allIssuers),
                    targetRadiologists: data.facilityRadiologists?.map(i => i.radiologistID) || [],
                    defaultRadiologistOptions: data.facilityRadiologists || [],
                    allProviders: data.allProviders || [],
                    targetProviders: data.facilityProviders || [],
                    defaultProviderOptions: data.facilityProviders || [],
                    allUsers: flatList,
                    facilityUserData: data.facilityUserData,
                    targetUsers: data.facilityUsers || [],
                    defaultUserOptions: data.facilityUsers ? getCommonItems(data.allUsers, data.facilityUserData, 'userID') : [],
                    primaryCarePhysicians: data.primaryCarePhysicians || [],
                    allCategories: filterInactive(data.allCategories),
                    targetCategories: data.facilityCategories?.map(i => i.categoryID) || []
                };

                setLists(newLists);

                if (data.facility) {
                    const facilityData = {
                        ...data.facility,
                        inactiveYN: data.facility.inactiveYN === 1,
                        b3AutoRecallYN: data.facility.b3AutoRecallYN === 1,
                        // The API model's IssuerofPatientID is a non-nullable Guid, so a facility with no issuer
                        // arrives as the empty GUID. Left as-is it passes `required` while the select shows blank,
                        // and saving it violates FK_Facility_IssuerofPatientID.
                        issuerofPatientID: data.facility.issuerofPatientID === '00000000-0000-0000-0000-000000000000'
                            ? ''
                            : data.facility.issuerofPatientID
                    };

                    if (data.facility.logo) {
                        setFacilityLogo(`data:image/jpeg;base64,${data.facility.logo}`);
                    }

                    // Use reset instead of setValue for better performance
                    reset({ facility: facilityData });
                }

                setIsLoading(false);
            } catch (error) {
                if (isMounted) {
                    toast.error("Failed to load facility information");
                    console.error(error);
                    setIsLoading(false);
                }
            }
        };

        loadData();

        return () => {
            isMounted = false;
        };
    }, [props.facilityID, flattenObject, getCommonItems, reset]);

    // Suppress ResizeObserver errors
    useEffect(() => {
        const errorHandler = (e) => {
            if (e.message.includes('ResizeObserver')) {
                e.stopImmediatePropagation();
                e.stopPropagation();
            }
        };

        window.addEventListener('error', errorHandler);

        return () => {
            window.removeEventListener('error', errorHandler);
        };
    }, []);

    const hidePane = useCallback(() => {
        setShowPane(false);

        setTimeout(() => {
            props.hidePane();
        }, 1000)
    }, [props]);

    const onError = useCallback((errors, e) => {
        toast.error("Please fill in all required information");
    }, []);

    const onSubmit = useCallback((parent) => {

        parent.facility.facilityID = props.facilityID || '00000000-0000-0000-0000-000000000000';
        parent.facility.inactiveYN = parent.facility.inactiveYN ? 1 : 0;
        parent.facility.b3AutoRecallYN = parent.facility.b3AutoRecallYN ? 1 : 0;

        parent.facility.defaultExamType = parent.facility.defaultExamType || null;
        parent.facility.defaultRadiologist = parent.facility.defaultRadiologist || null;
        parent.facility.defaultTech = parent.facility.defaultTech || null;

        let facilityVM = {
            facilityModel: parent.facility,
            radiologistsToUpdate,
            providersToUpdate,
            usersToUpdate,
            primaryCarePhysicians: lists.primaryCarePhysicians,
            categoriesToUpdate
        }

        updateFacilityInformation(facilityVM).then(data => {
            if (data.allFacilities) {
                toast.success(props.facilityID ? "Facility has been updated" : "Facility has been added");
                allFacilities.next(data.allFacilities);

                if (!props.facilityID && logoData?.name) {
                    insertLogo(logoData, data.facilityID);
                }

                hidePane();
            }
        });
    }, [props.facilityID, radiologistsToUpdate, providersToUpdate, usersToUpdate, lists.primaryCarePhysicians, categoriesToUpdate, logoData, hidePane]);

    const handleRadChange = useCallback((targetKeys, direction, moveKeys, itemToPush = null) => {
        setRadiologistsToUpdate(prev => {
            const rtu = [...prev];

            moveKeys.forEach((key) => {
                const radIdx = rtu.findIndex(r => r.id === key);
                if (radIdx >= 0) {
                    rtu[radIdx].delete = direction === 'left';
                } else {
                    rtu.push({
                        id: key,
                        delete: direction === 'left'
                    });
                }
            });

            return rtu;
        });

        setLists(prev => {
            const fullList = itemToPush ? [...prev.allRadiologists, itemToPush] : prev.allRadiologists;
            const defaultRads = fullList.filter(r => targetKeys.includes(r.radiologistID));

            return {
                ...prev,
                targetRadiologists: targetKeys,
                defaultRadiologistOptions: defaultRads,
                allRadiologists: fullList
            };
        });
    }, []);

    const closeAndUpdateRadiologist = useCallback((radiologistItem) => {
        setShowAddRadiologist();

        const targetKeys = [...lists.targetRadiologists, radiologistItem.radiologistID];
        handleRadChange(targetKeys, 'right', [radiologistItem.radiologistID], radiologistItem);
    }, [lists.targetRadiologists, handleRadChange, setShowAddRadiologist]);

    const handleProviderChange = useCallback((targetKeys, direction, moveKeys, itemToPush = null) => {
        setProvidersToUpdate(prev => {
            const ptu = [...prev];

            moveKeys.forEach((key) => {
                const provIdx = ptu.findIndex(r => r.id === key);
                if (provIdx >= 0) {
                    ptu[provIdx].delete = direction === 'left';
                } else {
                    ptu.push({
                        id: key,
                        delete: direction === 'left'
                    });
                }
            });

            return ptu;
        });

        setLists(prev => {
            const fullList = itemToPush ? [...prev.allProviders, itemToPush] : prev.allProviders;
            const defaultProvs = fullList.filter(p => targetKeys.includes(p.providerID));

            return {
                ...prev,
                targetProviders: targetKeys,
                defaultProviderOptions: defaultProvs,
                allProviders: fullList
            };
        });
    }, []);

    const closeAndUpdateProvider = useCallback((providerItem) => {
        setShowAddProvider();

        const targetKeys = [...lists.targetProviders, providerItem.providerID];
        handleProviderChange(targetKeys, 'right', [providerItem.providerID], providerItem);
    }, [lists.targetProviders, handleProviderChange, setShowAddProvider]);

    const handleUserChange = useCallback((targetKeys, direction, moveKeys, itemToPush = null) => {
        setUsersToUpdate(prev => {
            const utu = [...prev];

            moveKeys.forEach((key) => {
                const userIdx = utu.findIndex(r => r.id === key);
                if (userIdx >= 0) {
                    utu[userIdx].delete = direction === 'left';
                } else {
                    utu.push({
                        id: key,
                        delete: direction === 'left'
                    });
                }
            });

            return utu;
        });

        setLists(prev => {
            const fullList = itemToPush ? [...prev.allUsers, itemToPush] : prev.allUsers;
            const defaultUsers = fullList.filter(u => targetKeys.includes(u.userID));

            return {
                ...prev,
                targetUsers: targetKeys,
                defaultUserOptions: defaultUsers,
                allUsers: fullList
            };
        });
    }, []);

    const updateUsersCheckbox = useCallback((user) => {
        setUsersToUpdate(prev => {
            const utu = [...prev];
            const userIdx = utu.findIndex(r => r.id === user.userID);

            if (userIdx >= 0) {
                utu[userIdx].techOverride = user.techOverride;
            } else {
                utu.push({
                    id: user.userID,
                    delete: false,
                    techOverride: user.techOverride
                });
            }

            return utu;
        });

        setLists(prev => {
            const allUsers = [...prev.allUsers];
            const idx = allUsers.findIndex(u => u.userID === user.userID);
            if (idx !== -1) {
                allUsers[idx] = user;
            }

            return {
                ...prev,
                allUsers
            };
        });
    }, []);

    const closeAndUpdateUser = useCallback((user) => {
        setShowAddUser();

        const targetKeys = [...lists.targetUsers, user.userID];
        handleUserChange(targetKeys, 'right', [user.userID], user);
    }, [lists.targetUsers, handleUserChange, setShowAddUser]);

    const handleLogoUpload = useCallback((e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (props.facilityID) {
            insertLogo(file, props.facilityID);
        } else {
            setLogoData(file);

            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => setFacilityLogo(reader.result);
            reader.onerror = (error) => console.error('Error: ', error);
        }
    }, [props.facilityID]);

    const insertLogo = useCallback((file, facilityID) => {
        insertFacilityLogo(file, facilityID).then(data => {
            if (data) {
                toast.success("Logo has been uploaded");
                setValue("facility.logo", data);

                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => setFacilityLogo(reader.result);
                reader.onerror = (error) => console.error('Error: ', error);
            }
        });
    }, [setValue]);

    const closeAndUpdateIssuer = useCallback((issuer) => {
        setShowAddIssuer();

        setLists(prev => ({
            ...prev,
            allIssuers: [...prev.allIssuers, issuer]
        }));

        setValue("facility.issuerofPatientID", issuer.issuerofPatientID);
    }, [setShowAddIssuer, setValue]);

    const closeAndUpdatePCP = useCallback((pcp) => {
        setShowAddPCP();

        if ((props.facilityID && pcp.facilityID === props.facilityID) || !props.facilityID) {
            setLists(prev => ({
                ...prev,
                primaryCarePhysicians: [...prev.primaryCarePhysicians, pcp]
            }));
        }
    }, [props.facilityID, setShowAddPCP]);

    const handleCategoryChange = useCallback((targetKeys, direction, moveKeys, itemToPush = null) => {
        setCategoriesToUpdate(prev => {
            const ctu = [...prev];

            moveKeys.forEach((key) => {
                const catIdx = ctu.findIndex(r => r.id === key);
                if (catIdx >= 0) {
                    ctu[catIdx].delete = direction === 'left';
                } else {
                    ctu.push({
                        id: key,
                        delete: direction === 'left'
                    });
                }
            });

            if (ctu.find(item => !item.delete && (item.id === "7303caff-e0ec-4e1f-aa59-6af984691271" || item.id === "dcb66ee3-f85e-45b2-ae0d-c66614529415"))) {
                setValue('facility.b3AutoRecallYN', true);
            }

            return ctu;
        });

        setLists(prev => {
            const fullList = itemToPush ? [...prev.allCategories, itemToPush] : prev.allCategories;

            return {
                ...prev,
                targetCategories: targetKeys,
                allCategories: fullList
            };
        });
    }, [setValue]);

    const closeAndUpdateCategory = useCallback((category) => {
        setShowAddCategory();

        const targetKeys = [...lists.targetCategories, category.categoryID];
        handleCategoryChange(targetKeys, 'right', [category.categoryID], category);
    }, [lists.targetCategories, handleCategoryChange, setShowAddCategory]);

    const filterOption = useCallback((inputValue, option) => {
        const searchTerm = inputValue.toLowerCase();
        return option.fName?.toLowerCase().includes(searchTerm) ||
            option.lName?.toLowerCase().includes(searchTerm) ||
            `${option.fName} ${option.lName}`.toLowerCase().includes(searchTerm);
    }, []);

    // Memoize sorted lists
    const sortedDefaultUserOptions = useMemo(() => {
        return [...lists.defaultUserOptions].sort((a, b) =>
            a.fName.toUpperCase().localeCompare(b.fName.toUpperCase())
        );
    }, [lists.defaultUserOptions]);

    // Memoize sorted exam types
    const sortedExamTypes = useMemo(() => {
        return [...lists.allExamTypes].sort((a, b) =>
            a.examType.localeCompare(b.examType)
        );
    }, [lists.allExamTypes]);

    // Memoize sorted issuers
    const sortedIssuers = useMemo(() => {
        return [...lists.allIssuers].sort((a, b) =>
            a.issuerName.localeCompare(b.issuerName)
        );
    }, [lists.allIssuers]);

    if (isLoading) {
        return (
            <SlidingPane
                overlayClassName='pinkCard'
                className={theme === 'dark' ? "dark-theme" : 'light-theme'}
                isOpen={showPane}
                title={props.facilityID ? 'Manage Facility' : 'Add Facility'}
                onRequestClose={hidePane}
                shouldCloseOnEsc={false}
            >
                <div className="slide-pane-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <Spin size="large" tip="Loading facility information..." />
                </div>
            </SlidingPane>
        );
    }

    return (
        <SlidingPane
            overlayClassName='pinkCard'
            className={theme === 'dark' ? "dark-theme" : 'light-theme'}
            isOpen={showPane}
            title={props.facilityID ? 'Manage Facility' : 'Add Facility'}
            onRequestClose={hidePane}
            shouldCloseOnEsc={false}
        >

            <div className="slide-pane-body">
                <form>

                    <div className="row">
                    </div>
                    <div className="row">
                        <div className="form-group col-auto mx-auto">
                            {facilityLogo ?
                                <img src={facilityLogo} className="w-100 mh-150" alt="Facility Logo" />
                                :
                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No Facility Logo" className="m-0" />
                            }
                        </div>
                        <div className="form-group col-3 align-items-center">
                            <label htmlFor="upload-photo" className="color-pink hover">Browse...</label>
                            <input type="file" name="photo" id="upload-photo" accept="image/png, image/gif, image/jpeg" onChange={handleLogoUpload} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-lg-3 col-12">
                            <label className="form-label">Facility Name <span className="color-pink">*</span></label>
                            <input {...register("facility.facilityName", { required: true })} className="form-control-custom" autoComplete="off" type="text" />
                        </div>

                        <div className="form-group col-lg-3 col-12">
                            <label className="form-label">Facility Nickname</label>
                            <input {...register("facility.facilityNickname")} className="form-control-custom" autoComplete="off" type="text" />
                        </div>

                        <div className="form-group col-lg-3 col-12">
                            <label className="form-label">Legal Name</label>
                            <input {...register("facility.legalName")} className="form-control-custom" autoComplete="off" type="text" />
                        </div>

                        <div className="form-group col-lg-3 col-12">
                            <label className="form-label">DBA Name</label>
                            <input {...register("facility.dbaName")} className="form-control-custom" autoComplete="off" type="text" />
                        </div>

                        <div className="form-group col-lg-3 col-12">
                            <label className="form-label">Facility Number</label>
                            <input {...register("facility.facilityNumber")} className="form-control-custom" autoComplete="off" type="text" />
                        </div>

                        <div className="form-group col-lg-3 col-12">
                            <label className="form-label">Address 1</label>
                            <input {...register("facility.address1")} className="form-control-custom" autoComplete="off" type="text" />
                        </div>
                        <div className="form-group col-lg-3 col-12">
                            <label className="form-label">Address 2</label>
                            <input {...register("facility.address2")} className="form-control-custom" autoComplete="off" type="text" />
                        </div>
                        <div className="form-group col-lg-2 col-12">
                            <label className="form-label">City</label>
                            <input {...register("facility.city")} className="form-control-custom" autoComplete="off" type="text" />
                        </div>
                        <div className="form-group col-lg-2 col-12">
                            <label className="form-label">State</label>
                            <select className="form-control-custom" {...register("facility.state")}>
                                <option></option>
                                {states.map((state, idx) => <option key={idx} value={state.state_code}>{state.name}</option>)}
                            </select>
                        </div>

                        <div className="form-group col-lg-2 col-12">
                            <label className="form-label">ZIP</label>
                            <input {...register("facility.zip")} className="form-control-custom" autoComplete="off" type="text" />
                        </div>

                        <div className="form-group col-lg-3 col-12">
                            <label className="form-label">Phone</label>
                            <Controller
                                name="facility.phone"
                                control={control}
                                render={({ field }) => <NumberFormat {...field} className="form-control-custom" format="(###) ###-####" mask="_" onValueChange={(val) => setValue("facility.phone", val.formattedValue)} />}
                            />
                        </div>

                        <div className="form-group col-lg-3 col-12">
                            <label className="form-label">Fax</label>
                            <Controller
                                name="facility.fax"
                                control={control}
                                render={({ field }) => <NumberFormat {...field} className="form-control-custom" format="(###) ###-####" mask="_" onValueChange={(val) => setValue("facility.fax", val.formattedValue)} />}
                            />
                        </div>

                        <div className="form-group col-lg-3 col-12">
                            <label className="form-label">Email</label>
                            <input {...register("facility.email", {
                                pattern: {
                                    value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                    message: 'Please enter a valid email'
                                }
                            })} className="form-control-custom" />
                            {errors.email && <pre className="text-danger mb-0 ml-3">{errors.email.message}</pre>}
                        </div>

                        <div className="form-group col-3">
                            <label className="form-label">Inactive</label>
                            <div className="form-control-custom no-border">
                                <div className="custom-control custom-checkbox custom-control-inline">
                                    <input type="checkbox" className="custom-control-input" {...register("facility.inactiveYN")} />
                                    <label className="custom-control-label"></label>
                                </div>
                            </div>
                        </div>




                        <div className="form-group col-lg-3 col-12">
                            <label className="form-label">Default Technician</label>
                            <select className="form-control-custom" {...register("facility.defaultTech")}>
                                <option></option>
                                {sortedDefaultUserOptions.map((tech) => <option key={tech.userID} value={tech.userID}>{tech.fName} {tech.lName}</option>)}
                            </select>
                        </div>

                        <div className="form-group col-lg-3 col-12">
                            <label className="form-label">Default Exam Type</label>
                            <select className="form-control-custom" {...register("facility.defaultExamType")}>
                                <option></option>
                                {sortedExamTypes.map((et) => <option key={et.examTypeID} value={et.examTypeID}>{et.examType}</option>)}
                            </select>
                        </div>

                        <div className="form-group col-lg-3 col-12">
                            <label className="form-label">Default Radiologist</label>
                            <select className="form-control-custom" {...register("facility.defaultRadiologist")}>
                                <option></option>
                                {lists.defaultRadiologistOptions.map((rad) => <option key={rad.radiologistID} value={rad.radiologistID}>{rad.fName} {rad.lName}</option>)}
                            </select>
                        </div>

                        <div className="form-group col-lg-3 col-12">
                            <label className="form-label">Issuer of Patient <span className="color-pink">*</span><i className="fa fa-plus color-pink hover icon-in-label" onClick={() => setShowAddIssuer()} /></label>
                            <select className="form-control-custom" {...register("facility.issuerofPatientID", { required: true })}>
                                <option></option>
                                {sortedIssuers.map((i) => <option key={i.issuerofPatientID} value={i.issuerofPatientID}>{i.issuerName}</option>)}
                            </select>
                        </div>

                        <div className="form-group col-lg-3 col-12">
                            <label className="form-label">Hx Form Preference</label>
                            <select className="form-control-custom" {...register("facility.hxFormPreference")}>
                                <option></option>
                                <option>Short</option>
                                <option>Long</option>
                            </select>
                        </div>

                        <div className="form-group col-lg-3 col-12">
                            <label className="form-label">Density Verbiage</label>
                            <textarea {...register("facility.densityVerbiage")} className="form-control-custom" autoComplete="off" />
                        </div>

                        <div className="form-group col-lg-3 col-12">
                            <label className="form-label">Non-Dense Verbiage</label>
                            <textarea {...register("facility.nonDenseVerbiage")} className="form-control-custom" autoComplete="off" />
                        </div>

                        <div className="form-group col-lg-3 col-12">
                            <label className="form-label">Interface Type</label>
                            <select className="form-control-custom" {...register("facility.interfaceType")}>
                                <option value=""></option>
                                {FACILITY_INTERFACE_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                            </select>
                        </div>

                        <div className="form-group col-12">
                            <label className="form-label">Summary of Interface Impact on Workflow</label>
                            <Controller
                                name="facility.interfaceWorkflowSummary"
                                control={control}
                                render={({ field }) => (
                                    <Editor
                                        value={field.value || ''}
                                        onEditorChange={field.onChange}
                                        init={{
                                            height: 250,
                                            menubar: false,
                                            branding: false,
                                            plugins: 'lists',
                                            toolbar: 'bold italic underline | bullist numlist',
                                            valid_elements: 'p,br,strong/b,em/i,u,s,ul,ol,li'
                                        }}
                                    />
                                )}
                            />
                        </div>

                        <div className="form-group col-3">
                            <label className="form-label">Show Change Facility Button</label>
                            <div className="form-control-custom no-border">
                                <div className="custom-control custom-checkbox custom-control-inline">
                                    <input type="checkbox" className="custom-control-input" {...register("facility.showChangeFacility")} />
                                    <label className="custom-control-label"></label>
                                </div>
                            </div>
                        </div>

                        <div className="form-group col-3">
                            <label className="form-label">Supervising Tech</label>
                            <div className="form-control-custom no-border">
                                <div className="custom-control custom-checkbox custom-control-inline">
                                    <input type="checkbox" className="custom-control-input" {...register("facility.supervisingTech")} />
                                    <label className="custom-control-label"></label>
                                </div>
                            </div>
                        </div>

                        <div className="form-group col-lg-3 col-12">
                            <label className="form-label">Does this facility send B3 recall letters?</label>
                            <div className="form-control-custom no-border">
                                <div className="custom-control custom-checkbox custom-control-inline">
                                    <input type="checkbox" className="custom-control-input" {...register("facility.b3AutoRecallYN")} />
                                    <label className="custom-control-label"></label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col col-xl-6 col-12">
                            <hr />
                            <h5>Radiologist Mapping</h5>
                            <Transfer
                                titles={['Source', <i key="add-rad" className="fa fa-plus color-pink hover" onClick={() => setShowAddRadiologist()} />]}
                                className="grow"
                                dataSource={lists.allRadiologists}
                                showSearch
                                filterOption={filterOption}
                                rowKey={record => record.radiologistID}
                                targetKeys={lists.targetRadiologists}
                                onChange={handleRadChange}
                                render={item => `${item.fName} ${item.lName}`}
                                listStyle={{
                                    height: 300
                                }}
                            />
                        </div>

                        <div className="col col-xl-6 col-12">
                            <hr />
                            <h5>Provider Mapping</h5>
                            <Transfer
                                titles={['Source', <i key="add-prov" className="fa fa-plus color-pink hover" onClick={() => setShowAddProvider()} />]}
                                className="grow"
                                dataSource={lists.allProviders}
                                showSearch
                                filterOption={filterOption}
                                rowKey={record => record.providerID}
                                targetKeys={lists.targetProviders}
                                onChange={handleProviderChange}
                                render={item => `${item.fName} ${item.lName}`}
                                listStyle={{
                                    height: 300
                                }}
                            />
                        </div>



                        <div className="col col-xl-6 col-12">
                            <hr />
                            <h5>User Mapping</h5>
                            <TableTransfer
                                titles={['Source', <i key="add-user" className="fa fa-plus color-pink hover" onClick={() => setShowAddUser()} />]}
                                dataSource={lists.allUsers}
                                onChange={handleUserChange}
                                filterOption={filterOption}
                                rowKey={record => record.userID}
                                targetKeys={lists.targetUsers}
                                leftColumns={leftTableColumns}
                                rightColumns={rightTableColumns}
                                updateUsers={updateUsersCheckbox}
                                showSearch
                            />
                        </div>

                        <div className="col col-xl-6 col-12">
                            <hr />
                            <h5>Category Mapping</h5>
                            <Transfer
                                titles={['Source', <i key="add-cat" className="fa fa-plus color-pink hover" onClick={() => setShowAddCategory()} />]}
                                className="grow"
                                dataSource={lists.allCategories}
                                showSearch
                                filterOption={filterOption}
                                rowKey={record => record.categoryID}
                                targetKeys={lists.targetCategories}
                                onChange={handleCategoryChange}
                                render={item => item.category}
                                listStyle={{
                                    height: 300
                                }}
                            />
                        </div>

                        <div className="col col-xl-6 col-12">
                            <hr />
                            <h5>Primary Care Physician</h5>
                            <List
                                size="small"
                                header={<div className="d-flex justify-content-between"><div>{lists.primaryCarePhysicians.length} items</div><i className="fa fa-plus color-pink hover align-self-center" onClick={() => setShowAddPCP()} /></div>}
                                bordered
                                dataSource={lists.primaryCarePhysicians}
                                renderItem={item => <List.Item>{item.fName} {item.lName}</List.Item>}
                                className="h-300-list"
                                style={{ width: 300 }}
                            />
                        </div>


                    </div>
                </form>
            </div>

            <div className="modal-footer">
                <div className="form-group col-12 padding-25-10">
                    <button className="btn btn-submit" onClick={handleSubmit(onSubmit, onError)}>{props.facilityID ? 'Update Facility' : 'Add Facility'}</button>
                </div>
            </div>

            {showAddRadiologist && <RadiologistModal from='manageFacility' hideModal={closeAndUpdateRadiologist} />}
            {showAddProvider && <ProviderModal from='manageFacility' hideModal={closeAndUpdateProvider} />}
            {showAddUser && <ManageUser from='manageFacility' hidePane={closeAndUpdateUser} />}
            {showAddIssuer && <IssuerOfPatientModal from='manageFacility' hideModal={closeAndUpdateIssuer} />}
            {showAddPCP && <PCPModal from='manageFacility' facilityID={props.facilityID} hideModal={closeAndUpdatePCP} />}
            {showAddCategory && <CategoryModal from='manageFacility' facilityID={props.facilityID} hideModal={closeAndUpdateCategory} />}
        </SlidingPane>
    );
}

export default withRouter(ManageFacility);